export default __webpack_public_path__ + "static/media/nuScenes-lidarseg-text.c1a7b741.png";